// utils/video.js
export const getVideoSources = (fileName, apiUrl) => {
  if (!fileName) return [];

  const ext = fileName.split(".").pop().toLowerCase(); // récupère extension
  const baseUrl = `${apiUrl}/api/files/?categorie=videosPrestataires&file=${fileName}`;

  // Si c'est déjà un fichier avec extension connue, on retourne juste 1 source
  if (["mp4", "webm", "ogg"].includes(ext)) {
    return [{ src: baseUrl, type: `video/${ext}` }];
  }

  // Sinon, on tente plusieurs extensions possibles
  return [
    { src: `${baseUrl}.mp4`, type: "video/mp4" },
    { src: `${baseUrl}.webm`, type: "video/webm" },
    { src: `${baseUrl}.ogg`, type: "video/ogg" },
  ];
};
